export let headerIcon = {
	img: '',
	forceShow: false,
};

export const setter = (props) => {
	headerIcon = {
		...headerIcon,
		...props,
	};
};
